var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-info"},[_c('div',{staticClass:"dt-top"}),_c('InfoScanCode',{attrs:{"info":_vm.info},on:{"getPid":_vm.getPlan}}),(_vm.info.target)?_c('InfoPlan',{attrs:{"info":_vm.info}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }